import { z } from 'zod';

export const ErrorResponseSchema = z.object({
  error: z.string(),
  message: z.string(),
  status_code: z.number()
});
export type ErrorResponseType = z.infer<typeof ErrorResponseSchema>;

export const GetUserProgramSelectedChoicesRequestObjectSchema = z.object({
  program_id: z.number()
});
export type GetUserProgramSelectedChoicesRequestObjectType = z.infer<
  typeof GetUserProgramSelectedChoicesRequestObjectSchema
>;

const InstituteChoiceProductDetailsSchema = z.object({
  product_code: z.string(),
  extra_info: z.string().optional()
});

const SelectedChoiceSchema = z.object({
  id: z.string().uuid(),
  choice_type: z.enum(['INSTITUTE']),
  choice_name_enum: z.string(),
  institute_choice_products_details: z
    .array(InstituteChoiceProductDetailsSchema)
    .optional()
});

export const GetUserProgramSelectedChoicesResponseSchema = z.object({
  selected_choices: z.array(SelectedChoiceSchema)
});
export type GetUserProgramSelectedChoicesResponseType = z.infer<
  typeof GetUserProgramSelectedChoicesResponseSchema
>;

export const GetUserProgramSelectedChoicesBadRequestResponseSchema = z.object({
  response: z.string(),
  http_status_code: z.number(),
  res_status: z.enum(['INVALID_PROGRAM_ID'])
});
export type GetUserProgramSelectedChoicesBadRequestResponseType = z.infer<
  typeof GetUserProgramSelectedChoicesBadRequestResponseSchema
>;

export const CreateUserProgramSelectedChoiceRequestObjectSchema = z.object({
  program_id: z.number(),
  choice_type: z.enum(['INSTITUTE']),
  choice_name_enum: z.string()
});
export type CreateUserProgramSelectedChoiceRequestObjectType = z.infer<
  typeof CreateUserProgramSelectedChoiceRequestObjectSchema
>;

export const CreateUserProgramSelectedChoiceResponseSchema = z.object({
  message: z.string().optional()
});
export type CreateUserProgramSelectedChoiceResponseType = z.infer<
  typeof CreateUserProgramSelectedChoiceResponseSchema
>;

export const CreateUserProgramSelectedChoiceBadRequestResponseSchema = z.object(
  {
    response: z.string(),
    http_status_code: z.number(),
    res_status: z.enum([
      'INVALID_PROGRAM_ID',
      'INVALID_CHOICE_TYPE',
      'INVALID_CHOICE_NAME_ENUM'
    ])
  }
);
export type CreateUserProgramSelectedChoiceBadRequestResponseType = z.infer<
  typeof CreateUserProgramSelectedChoiceBadRequestResponseSchema
>;
